import { DocumentNotFoundDialogComponent } from '../dialogs/document-not-found-dialog/document-not-found-dialog.component';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { LdwRouterService } from '../../route/ldw-router.service';

export class DocumentHelper {
  constructor(
    private dialog: MatDialog,
    private routerService: LdwRouterService,
    private translate: TranslateService
  ) {}

  public documentNotFound(id: string | undefined) {
    let data = '';
    if (id == undefined || id == '') {
      data = this.translate.instant('DOCUMENT.DLG_DOCUMENTNOID');
    } else {
      data = this.translate.instant('DOCUMENT.DLG_DOCUMENTIDNOTFOUND', { id: id });
    }
    const confirmDialog = this.dialog.open(DocumentNotFoundDialogComponent, {
      data: data,
    });
    confirmDialog.afterClosed().subscribe(() => {
      this.routerService.navigateBack();
    });
  }

  public documentHistoryNotFound() {
    const confirmDialog = this.dialog.open(DocumentNotFoundDialogComponent, {
      data: this.translate.instant('DOCUMENT.DLG_DOCUMENTNOHISTORY'),
    });
    confirmDialog.afterClosed().subscribe(() => {
      this.routerService.navigateBack();
    });
  }
}
